import React from "react"

import type { VersionRow } from "../utils/testSetVersionDisplay"

const CELL = "border-b border-coval-border px-4 py-2.5 text-left align-top"

function formatType(type: string): string {
  if (!type) {
    return "—"
  }
  return type.charAt(0).toUpperCase() + type.slice(1).toLowerCase()
}

/**
 * Read-only rendering of a test set's test-case rows for one version — the version-history
 * counterpart of the editor grid. Presentational only: it shows the snapshot, never edits it.
 */
export const TestSetVersionGrid: React.FC<{ rows: VersionRow[] }> = ({
  rows,
}) => {
  if (rows.length === 0) {
    return (
      <p className="px-1 py-2 text-sm text-coval-text-muted">
        This version has no test cases.
      </p>
    )
  }

  return (
    <div className="overflow-x-auto rounded-md border border-coval-border">
      <table className="w-full border-collapse text-sm">
        <thead>
          <tr className="bg-surface-1 text-xs font-medium text-coval-text-muted">
            <th className={CELL}>Type</th>
            <th className={CELL}>Simulation Input</th>
            <th className={CELL}>Description</th>
            <th className={CELL}>Expected Behaviors</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr key={row.key}>
              <td className={`${CELL} whitespace-nowrap text-coval-text`}>
                {formatType(row.type)}
              </td>
              <td className={`${CELL} whitespace-pre-wrap text-coval-text`}>
                {row.simulationInput}
              </td>
              <td
                className={`${CELL} whitespace-pre-wrap text-coval-text-muted`}
              >
                {row.description}
              </td>
              <td className={CELL}>
                {row.expectedBehaviors.length > 0 ? (
                  <ul className="list-disc space-y-0.5 pl-4 text-coval-text">
                    {row.expectedBehaviors.map((behavior, index) => (
                      <li key={index}>{behavior}</li>
                    ))}
                  </ul>
                ) : null}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
